module.exports = __webpack_public_path__ + "img/arrow_up.6076d7de.svg";